import store from '../../store';
import { isPageValid } from 'ecx.saigon.ui.common';
import routeNames from '@/router/route-names';
import CalculatorWidget from '../../widgets/calculator';
import BudgetWidget from '../../widgets/budget';
import CarSearchWidget from '../../widgets/car-search';
import CarSearchVariantWidget from '../../widgets/car-search-variant';
import CarColourAndExtrasWidget from '../../widgets/car-colour-and-extras';
import QuoteUploadWidget from '../../widgets/quote-upload';

const componentMap = {
  [routeNames.calculator]: CalculatorWidget,
  [routeNames.budget]: BudgetWidget,
  [routeNames.carSearch]: CarSearchWidget,
  [routeNames.carSearchVariant]: CarSearchVariantWidget,
  [routeNames.quoteUpload]: QuoteUploadWidget,
  [routeNames.carColourAndExtras]: CarColourAndExtrasWidget
};

export default function (route) {
  return isPageValid(componentMap[route], store);
}
